import { ApiRoute, HttpMethod } from '../common';
import { PublishedArtifact } from '../publishedArtifact';
import { LocationId } from '../location';
import { WorkflowStartResult } from '../external';
import { BuilderTemplateId } from '../builderTemplate';
import { UploadId } from '../upload';
import { IPublishVideoToLocalRequest } from './video';

export interface PublishImageToLocalRequest {
    builderTemplateId: BuilderTemplateId;
    plannerId?: number | null;
    uploadId?: UploadId;
}

interface LocalPublishParams {
    locationId: LocationId;
}

export const LocalPublishApi = {
    publishLocal: new ApiRoute<PublishedArtifact, LocalPublishParams, PublishImageToLocalRequest, void>(
        HttpMethod.Post,
        path => path.literal('publish').literal('local').literal('location').param('locationId'),
    ),
    publishVideo: new ApiRoute<WorkflowStartResult, LocalPublishParams, IPublishVideoToLocalRequest, void>(
        HttpMethod.Post,
        path => path.literal('publish').literal('local').literal('location').param('locationId').literal('video'),
    ),
};
